<!-- =================================================================== -->
<!-- Card da tabela (header enxuto com filtros + resumo + tabela)         -->
<!-- Padrao "Extrato de Caixa": header em 3 regioes (titulo / filtros     -->
<!-- inline / acoes) e os filtros pesados numa gaveta lateral.           -->
<!-- =================================================================== -->
<div class="table-card">
  <div class="card-header card-header-table">
    <!-- Regiao esquerda: icone + titulo -->
    <div class="card-header-left">
      <div class="card-header-icon table-icon">
        <i class="pi pi-wallet"></i>
      </div>
      <span class="card-header-title">{{ 'contador.repasse.titulo' | translate }}</span>
    </div>

    <!-- Regiao central: filtros de uso frequente inline no header (periodo, busca
         por indicador, status e "somente contadores"). Todos no MESMO flex-container
         para quebrarem juntos como um grupo. -->
    <div class="card-header-filters">
      <div class="header-filter-field">
        <app-periodo-filtro
          [modo]="'avancado'"
          [valorPadrao]="'showAll'"
          styleClass="w-full"
          (periodoChanged)="onPeriodoChanged($event)">
        </app-periodo-filtro>
      </div>
      <!-- Seletor de indicador especifico (substitui a busca por texto). Filtra a
           listagem por indicadorId e habilita o "Pagar comissoes" por valor. -->
      <div class="header-filter-field header-filter-field--indicador">
        <p-dropdown
          [options]="indicadorOptions"
          [(ngModel)]="indicadorSelecionadoId"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          [showClear]="true"
          appendTo="body"
          styleClass="w-full"
          [placeholder]="'contador.repasse.filtros.indicador_placeholder' | translate"
          (onChange)="onIndicadorChange()">
        </p-dropdown>
      </div>
      <!-- Seletor de cupom especifico: filtra a listagem por cupomId da indicacao. -->
      <div class="header-filter-field header-filter-field--indicador">
        <p-dropdown
          [options]="cupomOptions"
          [(ngModel)]="cupomSelecionadoId"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          [showClear]="true"
          appendTo="body"
          styleClass="w-full"
          [placeholder]="'contador.repasse.filtros.cupom_placeholder' | translate"
          (onChange)="onCupomChange()">
        </p-dropdown>
      </div>
      <!-- Filtro de status (mesmo padrao da aba "Solicitacoes de Contador"). -->
      <div class="header-filter-field header-filter-field--status">
        <p-dropdown
          [options]="statusOptions"
          [(ngModel)]="statusAtual"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'contador.repasse.filtros.status' | translate"
          appendTo="body"
          styleClass="w-full"
          (onChange)="onStatusChange()">
        </p-dropdown>
      </div>
      <!-- "Somente contadores": ultimo filtro que restava na gaveta; movido para o
           header (gaveta removida) para reduzir cliques. -->
      <div class="header-filter-check">
        <p-checkbox
          [(ngModel)]="somenteContadores"
          [binary]="true"
          inputId="somenteContadores"
          (onChange)="onSomenteContadoresChange()">
        </p-checkbox>
        <label for="somenteContadores" class="header-filter-check-label">
          {{ 'contador.repasse.filtros.somente_contadores' | translate }}
        </label>
      </div>

      <!-- Pagar por valor: so habilita com um indicador selecionado no filtro. -->
      <div class="header-filter-action">
        <button pButton
          type="button"
          icon="pi pi-money-bill"
          class="btn-primary btn-sm"
          style="gap: 0.35rem"
          [label]="'contador.repasse.pagar_valor.botao' | translate"
          [pTooltip]="podePagarPorValor ? null : ('contador.repasse.pagar_valor.selecione_indicador' | translate)"
          tooltipPosition="top"
          [disabled]="!podePagarPorValor || processando"
          (click)="abrirDialogPagarPorValor()">
        </button>
      </div>

      <!-- Exportar: menu popup (PDF / Excel / CSV) das comissoes com os filtros atuais
           (nao depende de indicador). Espelha o padrao de operar-cliente. -->
      <div class="header-filter-action">
        <button pButton
          type="button"
          icon="pi pi-file-export"
          class="p-button-outlined p-button-secondary btn-sm"
          style="gap: 0.35rem"
          [label]="'contador.repasse.exportar.botao' | translate"
          [pTooltip]="'contador.repasse.exportar.tooltip' | translate"
          tooltipPosition="top"
          [attr.aria-label]="'contador.repasse.exportar.tooltip' | translate"
          [disabled]="exportando"
          [loading]="exportando"
          (click)="menuExportar.toggle($event)">
        </button>
        <p-menu #menuExportar [popup]="true" [model]="exportarItens" appendTo="body"></p-menu>
      </div>
    </div>
  </div>

  <div class="card-content">

    <!-- =============================================================== -->
    <!-- Cards de resumo (totais dos filtros aplicados) — antes da tabela -->
    <!-- =============================================================== -->
    <div class="resumo-grid">
      <div class="resumo-tile tile-total">
        <div class="resumo-icon"><i class="pi pi-list"></i></div>
        <div class="resumo-info">
          <span class="resumo-label">{{ 'contador.repasse.resumo.total_comissoes' | translate }}</span>
          <span class="resumo-valor">{{ resumo.totalComissoes }}</span>
        </div>
      </div>

      <div class="resumo-tile tile-pendente">
        <div class="resumo-icon"><i class="pi pi-clock"></i></div>
        <div class="resumo-info">
          <span class="resumo-label">{{ 'contador.repasse.resumo.total_pendente' | translate }}</span>
          <span class="resumo-valor">{{ resumo.totalPendente | guaraniFormat }}</span>
        </div>
      </div>

      <div class="resumo-tile tile-pago">
        <div class="resumo-icon"><i class="pi pi-check-circle"></i></div>
        <div class="resumo-info">
          <span class="resumo-label">{{ 'contador.repasse.resumo.total_pago' | translate }}</span>
          <span class="resumo-valor">{{ resumo.totalPago | guaraniFormat }}</span>
        </div>
      </div>

      <div class="resumo-tile tile-cancelado">
        <div class="resumo-icon"><i class="pi pi-times-circle"></i></div>
        <div class="resumo-info">
          <span class="resumo-label">{{ 'contador.repasse.resumo.total_cancelado' | translate }}</span>
          <span class="resumo-valor">{{ resumo.totalCancelado | guaraniFormat }}</span>
        </div>
      </div>
    </div>

    <!-- =============================================================== -->
    <!-- Barra de acao em lote (aparece quando ha selecao)               -->
    <!-- =============================================================== -->
    <div class="lote-bar" *ngIf="selecionadas.length > 0">
      <span class="lote-bar-info">
        {{ 'contador.repasse.lote.selecionadas' | translate: { count: selecionadas.length } }}
      </span>
      <!-- Botoes agrupados (acao primaria + destrutiva) num container proprio com gap
           pequeno, para ficarem coesos a direita e evitar o vao gigante que o
           space-between criava ao espalhar cada botao para uma ponta. -->
      <div class="lote-bar-actions">
        <button pButton
          type="button"
          icon="pi pi-check"
          class="btn-primary btn-sm"
          style="gap: 0.35rem"
          [label]="'contador.repasse.lote.botao' | translate: { count: selecionadas.length }"
          [disabled]="processando"
          (click)="abrirDialogLote()">
        </button>
        <button pButton
          type="button"
          icon="pi pi-ban"
          class="p-button-danger btn-sm"
          style="gap: 0.35rem"
          [label]="'contador.repasse.cancelar_lote.botao' | translate: { count: selecionadas.length }"
          [disabled]="processando"
          (click)="cancelarLote()">
        </button>
      </div>
    </div>

    <!-- Dica: a selecao em massa so e liberada com um indicador unico. -->
    <div class="selecao-hint" *ngIf="mostrarHintSelecao">
      <i class="pi pi-info-circle"></i>
      <span>{{ 'contador.repasse.selecao.hint_indicador' | translate }}</span>
    </div>

    <p-table [value]="comissoes"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [loading]="loading"
      sortField="geradoEm"
      [sortOrder]="-1"
      dataKey="id"
      selectionMode="multiple"
      [metaKeySelection]="false"
      [rowSelectable]="isRowSelectable"
      [(selection)]="selecionadas"
      [tableStyle]="{ width: '100%' }">

      <ng-template pTemplate="header">
        <tr>
          <th class="col-selecao" style="width: 3.5rem"
              [pTooltip]="podeSelecionar ? null : ('contador.repasse.selecao.hint_indicador' | translate)"
              tooltipPosition="top">
            <p-tableHeaderCheckbox [disabled]="!podeSelecionar"></p-tableHeaderCheckbox>
          </th>
          <th style="width: 13%">{{ 'contador.repasse.col_indicador' | translate }}</th>
          <th style="width: 12%">{{ 'contador.repasse.col_indicado' | translate }}</th>
          <th style="width: 11%">{{ 'contador.repasse.col_cupom' | translate }}</th>
          <th style="width: 10%" pSortableColumn="competencia">
            {{ 'contador.repasse.col_competencia' | translate }}
            <p-sortIcon field="competencia"></p-sortIcon>
          </th>
          <th style="width: 6%" pSortableColumn="porcentagemComissao">
            {{ 'contador.repasse.col_porcentagem' | translate }}
            <p-sortIcon field="porcentagemComissao"></p-sortIcon>
          </th>
          <th style="width: 11%" pSortableColumn="statusRepasse">
            {{ 'contador.repasse.col_status' | translate }}
            <p-sortIcon field="statusRepasse"></p-sortIcon>
          </th>
          <th style="width: 12%" pSortableColumn="valorComissao">
            {{ 'contador.repasse.col_valor' | translate }}
            <p-sortIcon field="valorComissao"></p-sortIcon>
          </th>
          <!-- Historico de saldo: trilha inline "data - saldoApos" por pagamento; ordenavel pelo saldo atual (`c.saldo`). -->
          <th style="width: 11%" pSortableColumn="saldo">
            {{ 'contador.repasse.col_historico_saldo' | translate }}
            <p-sortIcon field="saldo"></p-sortIcon>
          </th>
          <!-- Pagamentos: trilha inline "data - valorPago" por pagamento (nao ordenavel). -->
          <th style="width: 11%">{{ 'contador.repasse.col_pagamentos' | translate }}</th>
          <th style="width: 8%">{{ 'contador.repasse.col_acoes' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-comissao let-rowIndex="rowIndex">
        <!-- pSelectableRow: clique em QUALQUER lugar da linha alterna a selecao
             (metaKeySelection=false); shift+clique seleciona intervalo. Linhas
             nao-PENDENTES ficam fora via rowSelectable. -->
        <tr [pSelectableRow]="comissao"
            [pSelectableRowIndex]="rowIndex"
            [class.linha-selecionavel]="podeSelecionar && podePagar(comissao)">
          <!-- stopPropagation: sem isso o clique no checkbox alterna a selecao pelo
               p-tableCheckbox E borbulha ate o pSelectableRow do <tr>, gerando um
               double-toggle que se cancela (efeito liquido: nada). Barrar a propagacao
               no <td> deixa apenas o handler do checkbox atuar (mesmo padrao do <td class="actions">). -->
          <td class="col-selecao" (click)="$event.stopPropagation()">
            <!-- So PENDENTES sao selecionaveis e apenas com indicador unico
                 (selecao em massa habilitada). -->
            <p-tableCheckbox
              [value]="comissao"
              [disabled]="!podeSelecionar || !podePagar(comissao)">
            </p-tableCheckbox>
          </td>
          <td>{{ comissao.indicadorNome || '—' }}</td>
          <td>{{ nomeIndicado(comissao) }}</td>
          <td>{{ comissao.cupomNome || '—' }}</td>
          <td>{{ competenciaLabel(comissao.competencia) }}</td>
          <td>{{ comissao.porcentagemComissao }}%</td>
          <td>
            <div class="status-cell">
              <p-tag
                [value]="labelStatus(comissao.statusRepasse)"
                [severity]="severityStatus(comissao.statusRepasse)">
              </p-tag>
              <!-- Tag discreta "Parcial": PENDENTE com saldo ja abatido. -->
              <p-tag
                *ngIf="isParcial(comissao)"
                styleClass="tag-parcial"
                severity="info"
                [value]="'contador.repasse.tag_parcial' | translate">
              </p-tag>
            </div>
          </td>
          <td>{{ comissao.valorComissao | guaraniFormat }}</td>
          <!-- Historico de saldo: uma linha "data - saldoApos" por pagamento (trilha embutida
               em GET /comissoes). Fallback (sem trilha: PENDENTE integral / CANCELADA / legada):
               saldo simples atual — mesmo comportamento de antes. -->
          <td>
            <ng-container *ngIf="comissao.pagamentos?.length; else saldoSimples">
              <div class="pagamentos-inline">
                <span class="linha-pagamento" *ngFor="let p of comissao.pagamentos">
                  {{ dataLabel(p.dataPagamento) }} - {{ p.saldoApos | guaraniFormat }}
                </span>
              </div>
            </ng-container>
            <ng-template #saldoSimples>{{ comissao.saldo | guaraniFormat }}</ng-template>
          </td>
          <!-- Pagamentos: uma linha "data - valorPago" por pagamento. Fallback sem trilha
               (PENDENTE integral / CANCELADA / legada / backend pre-restart): preserva o
               comportamento anterior — valor consolidado quando ha pagamento (temPagamentos), senao "—". -->
          <td>
            <ng-container *ngIf="comissao.pagamentos?.length; else pagamentosFallback">
              <div class="pagamentos-inline">
                <span class="linha-pagamento" *ngFor="let p of comissao.pagamentos">
                  {{ dataLabel(p.dataPagamento) }} - {{ p.valorPago | guaraniFormat }}
                </span>
              </div>
            </ng-container>
            <ng-template #pagamentosFallback>
              <span *ngIf="temPagamentos(comissao); else semPagamentos">{{ totalPago(comissao) | guaraniFormat }}</span>
              <ng-template #semPagamentos>
                <span class="sem-acao">—</span>
              </ng-template>
            </ng-template>
          </td>
          <!-- stopPropagation: clique nos botoes de acao nao deve alternar a selecao da linha. -->
          <td class="actions" (click)="$event.stopPropagation()">
            <ng-container *ngIf="podePagar(comissao) || podeCancelar(comissao) || podeImprimirComprovante(comissao); else semAcao">
              <div class="actions-buttons">
                <button pButton
                  *ngIf="podePagar(comissao)"
                  type="button"
                  icon="pi pi-check"
                  class="p-button-text p-button-rounded p-button-sm p-button-success"
                  [pTooltip]="'contador.repasse.botao_pagar' | translate"
                  tooltipPosition="top"
                  [attr.aria-label]="'contador.repasse.botao_pagar' | translate"
                  [disabled]="processando"
                  (click)="abrirDialogPagar(comissao)">
                </button>
                <button pButton
                  *ngIf="podeCancelar(comissao)"
                  type="button"
                  icon="pi pi-ban"
                  class="p-button-text p-button-rounded p-button-sm p-button-danger"
                  [pTooltip]="'contador.repasse.botao_cancelar' | translate"
                  tooltipPosition="top"
                  [attr.aria-label]="'contador.repasse.botao_cancelar' | translate"
                  [disabled]="processando"
                  (click)="abrirDialogCancelar(comissao)">
                </button>
                <!-- Imprimir comprovante(s): comissao com >=1 pagamento (parcial ou paga).
                     Baixa o comprovante consolidado da comissao (spinner na linha enquanto baixa). -->
                <button pButton
                  *ngIf="podeImprimirComprovante(comissao)"
                  type="button"
                  icon="pi pi-print"
                  class="p-button-text p-button-rounded p-button-sm p-button-plain"
                  [pTooltip]="'contador.repasse.comprovante.botao_imprimir' | translate"
                  tooltipPosition="top"
                  [attr.aria-label]="'contador.repasse.comprovante.botao_imprimir' | translate"
                  [loading]="imprimindoComissaoId === comissao.id"
                  [disabled]="imprimindoComissaoId === comissao.id"
                  (click)="imprimirComprovantes(comissao)">
                </button>
              </div>
            </ng-container>
            <ng-template #semAcao>
              <span class="sem-acao">—</span>
            </ng-template>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="11" class="text-center p-5">
            <div class="flex flex-column align-items-center">
              <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
              <div class="text-gray-500 text-lg">{{ 'contador.repasse.vazio' | translate }}</div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr>
          <td colspan="11" class="text-center p-5">
            <div class="flex justify-content-center align-items-center">
              <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
              <span class="ml-3">{{ 'contador.repasse.carregando' | translate }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginacao (mesmo modelo da Lista de Vendas / Indicacoes):
         contagem a esquerda, "Itens por pagina" + dropdown a direita.
         Tabela lazy: a troca de pagina dispara onPageChange, que recarrega
         do backend. -->
    <div class="pagination-container">
      <div>
        <p-paginator
          (onPageChange)="onPageChange($any($event))"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="'contador.repasse.contagem' | translate"
          [first]="first" [rows]="rows"
          [totalRecords]="totalRecords" [showFirstLastIcon]="true">
        </p-paginator>
      </div>
      <div class="flex align-items-center">
        <span class="mx-1 text-color">{{ 'contador.repasse.itens_por_pagina' | translate }}</span>
        <!-- appendTo="body": o painel seria recortado pelo overflow do card;
             renderizado no body fica imune (igual aos demais dropdowns). -->
        <p-dropdown [options]="pageSizeOptions" optionLabel="label"
          optionValue="value" [(ngModel)]="rows"
          (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem"
          appendTo="body">
        </p-dropdown>
      </div>
    </div>
  </div>
</div>

<!-- =================================================================== -->
<!-- Dialog: Confirmar marcacao em lote (marcar varias como pagas)       -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="loteDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '32rem' }"
  (onHide)="fecharDialogLote()">

  <div class="dialog-wave-header dialog-wave-header--success">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-check" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador.repasse.lote.dialog_titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle">
          {{ 'contador.repasse.lote.selecionadas' | translate: { count: loteItens.length } }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'contador.repasse.lote.confirmar' | translate }}</p>

    <!-- Lista itemizada: uma linha por comissao selecionada, com valor editavel
         pre-preenchido com o saldo. Rola quando ha muitas selecionadas. -->
    <div class="lote-itens-lista">
      <div class="lote-item" *ngFor="let item of loteItens">
        <div class="lote-item-topo">
          <div class="lote-item-info">
            <span class="lote-item-indicado">{{ nomeIndicado(item.comissao) }}</span>
            <span class="lote-item-competencia">{{ competenciaLabel(item.comissao.competencia) }}</span>
          </div>
          <div class="lote-item-saldo">
            <span class="lote-item-saldo-label">{{ 'contador.repasse.pagar.saldo_label' | translate }}</span>
            <span class="lote-item-saldo-valor">{{ item.comissao.saldo | guaraniFormat }}</span>
          </div>
        </div>
        <p-inputNumber
          [(ngModel)]="item.valor"
          mode="decimal"
          [locale]="'es-PY'"
          [minFractionDigits]="0"
          [maxFractionDigits]="0"
          [min]="0"
          [max]="item.comissao.saldo"
          [useGrouping]="true"
          [disabled]="processando"
          styleClass="w-full"
          [inputStyle]="{ width: '100%' }"
          [attr.aria-label]="'contador.repasse.pagar.valor_label' | translate"
          (ngModelChange)="onLoteItemChange(item)">
        </p-inputNumber>
        <small class="erro-validacao" *ngIf="item.erro">{{ item.erro }}</small>
      </div>
    </div>

    <small class="dialog-pagar-ajuda">{{ 'contador.repasse.lote.ajuda_parcial' | translate }}</small>

    <!-- Rodape do conteudo: total a pagar (soma dos valores editados). -->
    <div class="lote-total">
      <span class="lote-total-label">{{ 'contador.repasse.lote.total_label' | translate }}</span>
      <span class="lote-total-valor">{{ loteTotal | guaraniFormat }}</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador.repasse.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="processando"
      (click)="fecharDialogLote()">
    </button>
    <button pButton
      [label]="'contador.repasse.confirmar' | translate"
      icon="pi pi-check"
      class="btn-primary"
      style="gap: 0.35rem"
      [disabled]="processando || loteInvalido"
      [loading]="processando"
      (click)="confirmarLote()">
    </button>
  </ng-template>
</p-dialog>

<!-- =================================================================== -->
<!-- Dialog: Confirmar repasse (marcar como pago)                        -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="pagarDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '32rem' }"
  (onHide)="fecharDialogPagar()">

  <div class="dialog-wave-header dialog-wave-header--success">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-check" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador.repasse.dialog_pagar_titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle" *ngIf="comissaoSelecionada">
          {{ comissaoSelecionada.indicadorNome }} — {{ competenciaLabel(comissaoSelecionada.competencia) }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'contador.repasse.confirmar_pagar' | translate }}</p>

    <div class="dialog-pagar-field" *ngIf="comissaoSelecionada">
      <!-- Saldo pendente (referencia do maximo permitido). -->
      <div class="dialog-pagar-saldo">
        <span class="dialog-pagar-saldo-label">{{ 'contador.repasse.pagar.saldo_label' | translate }}</span>
        <span class="dialog-pagar-saldo-valor">{{ comissaoSelecionada.saldo | guaraniFormat }}</span>
      </div>

      <label for="valorPagar" class="dialog-pagar-label">
        {{ 'contador.repasse.pagar.valor_label' | translate }}
      </label>
      <p-inputNumber
        inputId="valorPagar"
        [(ngModel)]="valorPagar"
        mode="decimal"
        [locale]="'es-PY'"
        [minFractionDigits]="0"
        [maxFractionDigits]="0"
        [min]="0"
        [max]="comissaoSelecionada.saldo"
        [useGrouping]="true"
        [disabled]="processando"
        styleClass="w-full"
        [inputStyle]="{ width: '100%' }"
        (ngModelChange)="onValorPagarChange()">
      </p-inputNumber>

      <small class="dialog-pagar-ajuda">{{ 'contador.repasse.pagar.ajuda_parcial' | translate }}</small>
      <small class="erro-validacao" *ngIf="erroValorPagar">{{ erroValorPagar }}</small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador.repasse.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="processando"
      (click)="fecharDialogPagar()">
    </button>
    <button pButton
      [label]="'contador.repasse.confirmar' | translate"
      icon="pi pi-check"
      class="btn-primary"
      style="gap: 0.35rem"
      [disabled]="processando"
      [loading]="processando"
      (click)="confirmarPagar()">
    </button>
  </ng-template>
</p-dialog>

<!-- =================================================================== -->
<!-- Dialog: Confirmar cancelamento da comissao                          -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="cancelarDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '32rem' }"
  (onHide)="fecharDialogCancelar()">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-ban" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador.repasse.dialog_cancelar_titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle" *ngIf="comissaoSelecionada">
          {{ comissaoSelecionada.indicadorNome }} — {{ competenciaLabel(comissaoSelecionada.competencia) }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'contador.repasse.confirmar_cancelar' | translate }}</p>
    <p class="dialog-wave-valor" *ngIf="comissaoSelecionada">
      {{ comissaoSelecionada.valorComissao | guaraniFormat }}
    </p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador.repasse.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="processando"
      (click)="fecharDialogCancelar()">
    </button>
    <button pButton
      [label]="'contador.repasse.confirmar' | translate"
      icon="pi pi-ban"
      class="p-button-danger"
      style="gap: 0.35rem"
      [disabled]="processando"
      [loading]="processando"
      (click)="confirmarCancelar()">
    </button>
  </ng-template>
</p-dialog>

<!-- =================================================================== -->
<!-- Dialog: Pagar POR VALOR (todas as pendentes do indicador)           -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="pagarPorValorDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '32rem' }"
  (onHide)="fecharDialogPagarPorValor()">

  <div class="dialog-wave-header dialog-wave-header--success">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-money-bill" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador.repasse.pagar_valor.dialog_titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle" *ngIf="indicadorSelecionadoNome">
          {{ indicadorSelecionadoNome }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'contador.repasse.pagar_valor.confirmar' | translate }}</p>

    <div class="dialog-pagar-field">
      <label for="valorTotalPagar" class="dialog-pagar-label">
        {{ 'contador.repasse.pagar_valor.valor_label' | translate }}
      </label>
      <p-inputNumber
        inputId="valorTotalPagar"
        [(ngModel)]="valorTotalPagar"
        mode="decimal"
        [locale]="'es-PY'"
        [minFractionDigits]="0"
        [maxFractionDigits]="0"
        [min]="0"
        [useGrouping]="true"
        [disabled]="processando"
        styleClass="w-full"
        [inputStyle]="{ width: '100%' }"
        [placeholder]="'contador.repasse.pagar_valor.valor_placeholder' | translate"
        (ngModelChange)="onValorTotalChange()">
      </p-inputNumber>

      <small class="dialog-pagar-ajuda">{{ 'contador.repasse.pagar_valor.ajuda' | translate }}</small>

      <small class="erro-validacao" *ngIf="erroValorTotal">{{ erroValorTotal }}</small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador.repasse.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="processando"
      (click)="fecharDialogPagarPorValor()">
    </button>
    <button pButton
      [label]="'contador.repasse.confirmar' | translate"
      icon="pi pi-check"
      class="btn-primary"
      style="gap: 0.35rem"
      [disabled]="processando"
      [loading]="processando"
      (click)="confirmarPagarPorValor()">
    </button>
  </ng-template>
</p-dialog>

<!-- =================================================================== -->
<!-- Dialog: Confirmar cancelamento em LOTE (destrutivo)                 -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="cancelarLoteDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '32rem' }"
  (onHide)="fecharDialogCancelarLote()">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-ban" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador.repasse.cancelar_lote.confirmacao_titulo' | translate }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'contador.repasse.cancelar_lote.confirmacao' | translate: { count: selecionadas.length } }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador.repasse.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="processando"
      (click)="fecharDialogCancelarLote()">
    </button>
    <button pButton
      [label]="'contador.repasse.cancelar_lote.confirmar' | translate"
      icon="pi pi-ban"
      class="p-button-danger"
      style="gap: 0.35rem"
      [disabled]="processando"
      [loading]="processando"
      (click)="confirmarCancelarLote()">
    </button>
  </ng-template>
</p-dialog>

<p-toast />
